import axios from 'axios';

// For now, modlink-frontend will primarily use modlink-backend
const apiUrl = import.meta.env.VITE_API_ENDPOINT || 'http://localhost:3333/';

const api = axios.create({
	baseURL: apiUrl,
});

api.interceptors.request.use((config) => {
	const token = localStorage.getItem('token');
	// Só adiciona o header se o token for válido (não vazio, null ou undefined)
	if (token && token.trim() !== '' && token !== 'null' && token !== 'undefined') {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
});

// Interceptor para lidar com respostas 401 (não autorizado)
api.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 401) {
			// Remove token inválido automaticamente
			localStorage.removeItem('token');
		}
		return Promise.reject(error);
	}
);

export { api, apiUrl };
